import { inject } from '@angular/core';
import { OperatorInput, OperatorOutput } from './models/models';
import { IOperatorClass } from './OperatorClass';
import { CompanyService } from 'src/app/company/company.service';
import { catchError, first, firstValueFrom, map, Observable, of } from 'rxjs';

export class PrfCreator implements IOperatorClass {

      private companyService = inject(CompanyService);

    doesGroupExist(operatorInput: OperatorInput): Observable<boolean> {
        return this.companyService.getGroupname(operatorInput.prfyear, operatorInput.prfGroup).pipe(
            map((data: any) => {
                console.log('Group exists:');
                return true;
            }),
            catchError((error) => {
                console.error('Error checking company existence:', error);
                return of(false);
            })
        );  

    }

    async runOperator(operatorInput: OperatorInput): Promise<OperatorOutput> {
        if (!operatorInput.prfyear) {
            return {
                status: 'error',
                operatorInput: operatorInput,
                message: ['PRF year is required']
            };
        }
        if (!operatorInput.prfnumber) {
            return {
                status: 'error',
                operatorInput: operatorInput,
                message: ['PRF number is required']
            };
        }
        if (!operatorInput.prfGroup) {
            return {
                status: 'error',
                operatorInput: operatorInput,
                message: ['Group code is required']
            };
        }
        
        var doesGroupExist = await firstValueFrom(this.doesGroupExist(operatorInput));
        if (!doesGroupExist) {
            return {
                status: 'error',
                operatorInput: operatorInput,
                message: ['Group does not exist and/or you dont have permission to the group']
            };
        }

        // TODO: Implement PRF creation logic
        return Promise.resolve({
            status: 'success',
            operatorInput: operatorInput,
        });
    }
}
